var $                                   = require('jquery');
var video                               = require('video');

/**
 *
 * jQuery.SlickVideo
 * @author Profitroom
 *
 * wymagene skrypty slick.js, video.js, 
 * dodatkowe device.js
 */

function slickVideo(options) {
    if(!$('html').hasClass('ie9')) {
        var $this = this;

        if(typeof vSlickData != "object"){
            vSlickData = {
                videoTested: false,
                videoAllow: false,
                videoBuffering: false
            };
        }

        this.options = $.extend({
            vslides         : '.vSlick',
            slick_slide     : '.item',
            slick_img       : '.slick-img',
            video_contents  : '.video-contents',
            video_js        : '.video-js',
            slick_autoplaySpeed : 3000,
            slick_speed     : 300,
            autoplay        : true,
            video_muted     : true,
            dots            : false,
            arrows          : false,
            mobile: false
        }, options);

        
        this.loadVideo = function(slider) {
            slider.$slides.each(function(index, slid) {
                if($(slid).hasClass('video')){
                    var slideHTML = $(slid).clone(),
                        videoHTML = $(slid).find('.video-contents').html();
                    $(slid).html(videoHTML);
                    $(slid).append(slideHTML.html());
                    $(slid).find($this.options.slick_img).css('opacity','');

                    $videoEl = $(slid).find('video');
                    if($this.options.mobile){
                         slider.options.video[index] = $videoEl.length && videojs($videoEl.get(0), $videoEl.data('setup') || {});
                    } else {
                         slider.options.video[index] = $videoEl.length && videojs($videoEl.get(0), $videoEl.data('setup-mobile') || {});    
                    }
                    if(slider.options.video[index].eb == 'Flash'){
                        slider.options.video[index] == null;
                        $(slid).removeClass('video');
                        $(slid).find($this.options.video_js).remove();
                        return;
                    }
                    slider.options.video[index].controls(false);
                    slider.options.video[index].ready = false;
                    slider.options.video[index].playNow = false;
                }
            });
            if($this.options.mobile)
                return;
            testing = false; //zabezpieczenie jesli wszystkie wideo w cache
            if(slider.options.video.length){
                $.each(slider.options.video, function(index, video) {
                    if(slider.options.video[index]){
                        if(!vSlickData.videoTested && slider.options.video[index].bufferedPercent() != '1'){
                            $this.testVideo(slider, index);
                            testing = true;
                            return false;
                        }
                    }
                });
                if(!testing) {
                    slider.options.videobuffered = true;
                }
            }
        };

        this.testVideo = function(slider, videoid) {
            if(!vSlickData.videoTested && !vSlickData.videoBuffering){
                vSlickData.videoBuffering = true;
                slider.options.video[videoid].on('progress', function checkTestProgress () {
                   setTimeout(function(){
                        var movieDuration = slider.options.video[videoid].duration();
                        var testDurationToMovieDurationRatio = movieDuration && 1e-3 * $this.options.testingTime / movieDuration;
                        var checkPassed = slider.options.video[videoid].bufferedPercent() > testDurationToMovieDurationRatio;

                        if(vSlickData.videoTested)
                            return;
                        if (checkPassed) {
                            vSlickData.videoAllow = true;

                            if($(slider.$slides[slider.currentSlide]).hasClass('video')){
                                if(slider.options.video[slider.currentSlide]){
                                    if(!$this.options.mobile){
                                        slider.options.video[slider.currentSlide].playNow = true;
                                        slider.options.video[slider.currentSlide].play(); //ladniejszy efekt jeśli odpalam przed zaladowniem
                                        setTimeout(function(){
                                            $(document).trigger('play-slick-video-onfirstslide');
                                        },0);
                                        $(slider.$slides[slider.currentSlide]).find($this.options.slick_img).css('display','none');
                                        $(slider.$slides[slider.currentSlide]).find($this.options.video_js).css('display','block');
                                    } else {
                                        slider.options.video[slider.currentSlide].currentTime(0);
                                        $(slider.$slides[slider.currentSlide]).find($this.options.slick_img).css('display','none');
                                        $(slider.$slides[slider.currentSlide]).find($this.options.video_js).css('display','block');
                                    }
                                }
                                if( typeof slider.options.video[videoid] !== typeof undefined ){
                                    slider.options.video[videoid].on('ended', function () {
                                        slider.options.video[videoid].currentTime(0);
                                        slider.options.video[videoid].pause();
                                        slider.options.video[videoid].playNow = false;
                                        if(slider.$slides.length === 1){
                                            slider.options.video[slider.currentSlide].playNow = true;
                                            slider.options.video[slider.currentSlide].play();
                                        }else {
                                            slider.slickPlay();
                                            slider.slickNext();
                                        }
                                    });
                                }
                            }
                        }
                        else {
                            $($this.options.slick_slide).addClass('no-video');
                            vSlickData.videoAllow = false;
                            slider.options.video[videoid].pause();
                            slider.options.video.slice(videoid, 1);
                        }
                        vSlickData.videoTested = true;
                        vSlickData.videoBuffering = false;

                    }, $this.options.testingTime);
                    slider.options.video[videoid].off('progress', checkTestProgress);
                });
                slider.options.video[videoid].on('error', function () {
                    //console.log('video error');
                });
                slider.options.video[videoid].play();
                setTimeout(function(){
                    slider.options.video[videoid].pause();
                }, 0);
            }
        };

        this.elSize = function(obj, slick) {
            webWidth = $(slick).width();
            webHeight = $(slick).height();
            imgWidth = obj.data('width');
            imgHeight = obj.data('height');
            resize = imgWidth / imgHeight;
            newHeight = parseInt(webWidth / resize)+1;

            if(newHeight < webHeight){
                newWidth = parseInt(webHeight * resize)+1;
                obj.css({
                    '-webkit-transform': 'translateY(0px)',
                    '-ms-transform': 'translateY(0px)',
                    'transform': 'translateY(0px)'
                });
                obj.css({
                    '-webkit-transform': 'translateX('+parseInt((webWidth-newWidth)/2)+'px)',
                    '-ms-transform': 'translateX('+parseInt((webWidth-newWidth)/2)+'px)',
                    'transform': 'translateX('+parseInt((webWidth-newWidth)/2)+'px)'
                });
                obj.width(parseInt(newWidth)+1+'px');
                obj.height(webHeight+'px');
                return;
            }
            obj.css({
                '-webkit-transform': 'translateX(0px)',
                '-ms-transform': 'translateX(0px)',
                'transform': 'translateX(0px)'
            });
            obj.css({
                '-webkit-transform': 'translateY('+parseInt((webHeight-newHeight)/2)+'px)',
                '-ms-transform': 'translateY('+parseInt((webHeight-newHeight)/2)+'px)',
                'transform': 'translateY('+parseInt((webHeight-newHeight)/2)+'px)'
            });
            obj.width(webWidth+'px');
            obj.height(parseInt(newHeight)+'px');
            return;
        };

       $this.vslides = new Array();

        $(this.options.vslides).each(function(i, el) {
            if ($(el)) {
                $this.vslides.push($(el));
            }
        });

        $($this.vslides).each(function(i, slickshow) {        
            $(slickshow).on('init', function(event, slider){
                setTimeout(function(){
                    $(document).trigger('slick-video-init', [slickshow, event, slider]);
                },0);
                if($('html').hasClass('mobile') || $('html').hasClass('tablet')){
                    $this.options.mobile = true;
                }
                if($.browser['msie'] && $.browser['version'] == '8.0'){
                    $(slider.$slides).find('.video');
                } else {
                    $this.loadVideo(slider);
                }
                if($(slider.$slides[0]).hasClass('video')){
                    if(slider.options.video[0]){
                        slider.options.video[0].on('play', function () {
                            slider.slickPause();
                            slider.options.video[0].playNow = true;
                        });
                        slider.options.video[0].on('ended', function () {
                            slider.options.video[0].pause();
                            slider.options.video[0].playNow = false;
                            slider.slickPlay();
                            slider.slickNext();
                        });
                        $this.elSize($(slider.$slides[0]).find($this.options.video_js), slickshow);
                        $this.elSize($(slider.$slides[0]).find($this.options.slick_img), slickshow);
                        if(!$this.options.mobile){
                            if((vSlickData.videoTested && vSlickData.videoAllow)||slider.options.videobuffered) {
                                slider.options.video[0].playNow = true;
                                slider.options.video[0].play(); //ladniejszy efekt jezeli odpalam przed zaladowniem
                                $(slider.$slides[0]).find($this.options.slick_img).css('display','none');
                                $(slider.$slides[0]).find($this.options.video_js).css('display','block');
                            }
                        } else {
                            slider.options.video[0].currentTime(0);
                            $(slider.$slides[0]).find($this.options.slick_img).css('display','none');
                            $(slider.$slides[0]).find($this.options.video_js).css('display','block');
                        }
                    }
                }else{
                    $this.elSize($(slider.$slides[0]).find($this.options.slick_img), slickshow);
                }
            });
            $(slickshow).on('beforeChange', function(event, slider, index, next){
                setTimeout(function(){
                    $(document).trigger('slick-video-beforeChange', [slickshow, event, slider, index]);
                },0);
                $this.elSize($(slider.$slides[next]).find($this.options.slick_img), slickshow);
                if($(slider.$slides[index]).hasClass('video')){
                    if(slider.options.video[index] && slider.options.video[index].playNow){
                        slider.options.video[index].pause();
                        slider.options.video[index].playNow = false;
                    }
                }
                if($(slider.$slides[next]).hasClass('video')){
                    if(slider.options.video[next]){
                        $this.elSize($(slider.$slides[next]).find($this.options.video_js), slickshow);
                        if(!$this.options.mobile){
                            if((vSlickData.videoTested && vSlickData.videoAllow)||slider.options.videobuffered) {
                                slider.options.video[next].currentTime(0);
                                slider.options.video[next].playNow = true;
                                slider.options.video[next].play();
                                $(slider.$slides[next]).find($this.options.slick_img).css('display','none');
                                $(slider.$slides[next]).find($this.options.video_js).css('display','block');
                            }
                        } else {
                            slider.options.video[next].currentTime(0);
                            $(slider.$slides[next]).find($this.options.slick_img).css('display','none');
                            $(slider.$slides[next]).find($this.options.video_js).css('display','block');
                        }
                        slider.options.video[next].muted($this.options.video_muted);
                    }
                }
            });
            $(slickshow).on('afterChange', function(event, slider, index){
                setTimeout(function(){
                    $(document).trigger('slick-video-afterChange', [slickshow, event, slider, index]);
                },0);
                if($(slider.$slides[index]).hasClass('video')){
                    if(slider.options.video[index]){
                        if(!$this.options.mobile){
                            slider.slickPause();
                            if(((vSlickData.videoTested && vSlickData.videoAllow) || slider.options.videobuffered) && !slider.options.video[index].playNow)
                                slider.options.video[index].play();

                            setTimeout(function(){
                                if(!slider.options.video[index].playNow){
                                   slider.slickPlay();
                                   slider.slickNext();
                                }
                            }, slider.options.autoplaySpeed);

                            slider.options.video[index].on('play', function () {
                                $(slider.$slides[index]).find($this.options.slick_img).css('display','none');
                                $(slider.$slides[index]).find($this.options.video_js).css('display','block');
                                slider.options.video[index].playNow = true;
                                slider.options.video[index].muted($this.options.video_muted);
                            });
                            slider.options.video[index].on('ended', function () {
                                //slider.options.video[index].currentTime(0);
                                slider.options.video[index].pause();
                                slider.options.video[index].playNow = false;
                                slider.slickPlay();
                                slider.slickNext();
                            });
                        } else {
                            slider.options.video[index].on('play', function () {
                                slider.slickPause();
                                slider.options.video[index].playNow = true;
                            });
                            slider.options.video[index].on('ended', function () {
                                slider.options.video[index].currentTime(0);
                                slider.options.video[index].pause();
                                slider.options.video[index].playNow = false;
                                slider.slickPlay();
                                slider.slickNext();
                            });
                            slider.options.video[index].on('pause', function () {
                                slider.options.video[index].playNow = false;
                                setTimeout(function(){
                                    if(!slider.options.video[index].playNow){
                                       slider.slickPlay();
                                       slider.slickNext();
                                    }
                                }, slider.options.autoplaySpeed);
                            });
                        }
                    }
                }
            });

            slickshow.slick({
                autoplay        : $this.options.autoplay,
                slide           : $this.options.slick_slide,
                pauseOnHover    : false, //wymagane false
                fade            : true,
                slidesToShow: 1,
                slidesToScroll: 1,
                lazyLoad: 'ondemand',
                dots: $this.options.dots,
                arrows: $this.options.arrows,
                touchMove: false,
                swipeToSlide: false,
                autoplaySpeed: $this.options.slick_autoplaySpeed,
                speed : $this.options.slick_speed,
                video: [],
                videobuffered: false
            });

            $(window).on('load resize orientationchange', function() {
                slick_video = $(slickshow).find('.slide.video > .video-js');
                if(slick_video.length){
                    $this.elSize(slick_video, slickshow);
                }
            });
        });
    } else {
        $('.photo-slider').slick({
            infinite: true,
            speed: 1000,
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            cssEase: 'cubic-bezier(0.75,0.25,0.25,1)',
            dots: true,
            arrows: false,
            appendDots: document.querySelector('.photo-slider_dots-hld'),
            fade: true
        });
    }
}

module.exports = slickVideo;